<template lang="pug">
.settings-account
	page-header
		h1.highlight Your account
		template(slot="actions")
			el-button(type="primary" @click='save', :loading="loading") Save settings
	page
		partial-two-col
				template(slot="left")
						h2 Personal details
						p Please keep your name and email address up to date.
				template(slot="right")
						el-card(v-loading="$apollo.loading")
								el-form(:rules="rules",:model="User", ref="detailsForm",label-position="left", label-width='200px', v-if="!$apollo.loading")
										el-form-item(prop="first_name", label="First name")
												el-input(v-model="User.first_name")
										el-form-item(prop="last_name", label="Last name")
												el-input(v-model="User.last_name")
										el-form-item(prop="email", label="Email address")
												el-input(v-model="User.email")
		partial-two-col
				template(slot="left")
						h2 Change password
						p Your password should be secure and kept in a safe place, ideally in your mind. It needs to contain a lowercase letter, an uppercase letter, a number and a special character.
				template(slot="right")
					el-card(v-loading="$apollo.loading")
							el-form(:rules="rules",:model="User", ref="passwordForm",label-position="left", label-width='200px')
									el-form-item(prop="password", label="Password")
											el-input(placeholder="Password", v-model="User.password", type="password")
									el-form-item(prop="confirm_password", label="Confirm password")
											el-input(placeholder="Confirm password", v-model="User.confirm_password", type="password")
									el-form-item
											two-factor-toggle(:user="User", @options:updated="$apollo.queries.User.refetch()")
		partial-two-col
				template(slot="left")
						h2 Notification settings
						p Use this section to tailor the emails your receive from us. We recommend keeping them all on because they are super useful.
				template(slot="right")
						el-card(v-loading="$apollo.loading")
								el-form(:rules="rules",:model="User", ref="notificationsForm",label-position="left", label-width='500px', v-if="!$apollo.loading")
										el-form-item(label="Receive school access notifications")
												el-switch(v-model="User.notify_approval", @change="notifyApprovalSwitch", active-color="#4c85ff", inactive-color="#ff4949", active-value=true, inactive-value=false)
										el-form-item(label="Receive product updates")
												el-switch(v-model="User.notify_product", active-color="#4c85ff", inactive-color="#ff4949", active-value=true, inactive-value=false)
										el-form-item(label="Receive school referral notifications")
												el-switch(v-model="User.notify_on_school_referral", active-color="#4c85ff", inactive-color="#ff4949", active-value=true, inactive-value=false)
										el-form-item(label="Only receive notifications for school's requested by my account")
												el-switch(v-model="User.notify_self_only", @change="notifySelfOnlySwitch", active-color="#4c85ff", inactive-color="#ff4949", active-value=true, inactive-value=false)
										el-form-item(label="Receive permission approval notifications")
												el-switch(v-model="User.notify_on_scope_approval", active-color="#4c85ff", inactive-color="#ff4949", active-value=true, inactive-value=false)
</template>

<script>
import gql from "graphql-tag";
import { isEmpty, every, omit, cloneDeep } from "lodash";
import TwoFactorToggle from "@/views/settings/includes/TwoFactorToggle";
import { emailValidator, passwordValidator } from "@/libraries/validator.lib";

export default {
	name: "AccountSettings",
	components: {
		TwoFactorToggle
	},
	data() {
		const validateConfirmPassword = (rule, value, callback) => {
			if (isEmpty(this.User.password)) {
				callback();
			}

			if (value !== this.User.password) {
				callback(new Error("Two passwords don't match!"));
			} else {
				callback();
			}
		};
		return {
			loading: false,
			detailsForm: {
				forename: null,
				surname: null,
				email: null
			},
			rules: {
				first_name: [{ required: true, message: "Please provide a first name", trigger: "blur", whitespace: true }],
				last_name: [{ required: true, message: "Please provide a last name", trigger: "blur", whitespace: true }],
				email: [{ validator: emailValidator, required: true, message: "Please provide a valid email address", trigger: "blur" }],
				password: [{ validator: passwordValidator, trigger: "blur" }],
				confirm_password: [{ validator: validateConfirmPassword, trigger: "change" }]
			},
			User: {
				password: null,
				confirm_password: null
			}
		};
	},

	mounted() {
		window.vue.$on("settings:updated", () => {
			this.$apollo.queries.User.refetch();
		});
	},

	methods: {
		async save() {
			this.loading = true;

			let valid = [];

			try {
				valid = [await this.$refs.detailsForm.validate(), await this.$refs.passwordForm.validate(), await this.$refs.notificationsForm.validate()];

				if (every(valid)) {
					await this.$apollo.mutate({
						mutation: gql`
							mutation SaveUser($input: SaveUserInput!) {
								SaveUser(input: $input) {
									id
									first_name
									last_name
									email
									notify_approval
									notify_product
									notify_on_school_referral
									notify_self_only
									notify_on_scope_approval
								}
							}
						`,
						variables: {
							input: omit(this.User, ["id", "confirm_password", "__typename"])
						}
					});

					this.$message.success("Saved successfully");
				} else {
					this.$message.error("Failed to save, please contact support if problem persists.");
				}
			} catch (error) {
				this.$message.error("Failed to save, please contact support if problem persists.");
			}

			this.User.password = null;
			this.User.confirm_password = null;

			this.loading = false;
		}
	},

	apollo: {
		User: {
			query: gql`
				{
					User {
						id
						first_name
						last_name
						email
						notify_approval
						notify_product
						notify_on_school_referral
						notify_self_only
						notify_on_scope_approval
						enable_2fa
					}
				}
			`,
			fetchPolicy: "no-cache",
			update(r) {
				let obj = cloneDeep(r.User);

				return {
					...obj,
					password: null,
					confirm_password: null
				};
			}
		}
	}
};
</script>
